module.exports = __webpack_public_path__ + "media/images/athletes/640-e9eb064cb6b70f80520cfd6b16eb8001.png";